class AuthController{
    constructor(
        $auth
    ) {
        'ngInject';
        this.$auth = $auth;
    }
}

export default AuthController;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/auth.controller.js
 **/